import { GraduationCap } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { PROVIDERS } from "@/components/home/CertificationsSection";

const ITEMS = PROVIDERS.flatMap((p) => p.certs.map((c) => [p.name, c]));

export const CertMarquee = () => {
  const { tr } = useLang();
  return (
    <div data-testid="cert-marquee" dir="ltr" className="bg-[#09090b] text-white border-y border-[#27272a] py-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-2"><span className="text-[10px] uppercase tracking-[0.25em] font-mono text-[#E0262C] inline-flex items-center gap-2">
        <GraduationCap className="w-3.5 h-3.5" /> {tr("Certificazioni IT in corso", "IT certifications in progress")}
      </span></div>
      <div className="marquee overflow-hidden">
        <div className="marquee-track" style={{ "--marquee-dur": "60s" }}>
          {[...ITEMS, ...ITEMS].map(([org, cert], i) => (
            <span key={i} className="flex items-center gap-2 px-6 whitespace-nowrap text-sm">
              <span className="font-display font-semibold">{org}</span>
              <span className="text-[#a1a1aa]">{cert}</span>
              <span className="w-1.5 h-1.5 bg-[#E0262C] ml-4" />
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
